import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

const Wrapper = ({
  children,
  classes,
  componentId,
  cssSmall,
  cssMedium,
  cssLarge,
  cssXLarge,
  cssXXLarge
}) => {
  const cssSmallContent = cssSmall ? `#${componentId} {${cssSmall}}` : '';
  const cssMediumContent = cssMedium
    ? `
      @media print, screen and (min-width: 40em) {
        #${componentId} {${cssMedium}}
      }`
    : '';
  const cssLargeContent = cssLarge
    ? `
      @media print, screen and (min-width: 64em) {
        #${componentId} {${cssLarge}}
      }`
    : '';
  const cssXLargeContent = cssXLarge
    ? `
      @media print, screen and (min-width: 75em) {
        #${componentId} {${cssXLarge}}
      }`
    : '';
  const cssXXLargeContent = cssXXLarge
    ? `
      @media print, screen and (min-width: 90em) {
        #${componentId} {${cssXXLarge}}
      }`
    : '';

  const content = `${cssSmallContent} ${cssMediumContent} ${cssLargeContent} ${cssXLargeContent} ${cssXXLargeContent}`;

  return (
    <div className={classes} id={componentId}>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
      {children}
    </div>
  );
};

export default DisplayComponent(Wrapper);
